import { render, staticRenderFns } from "./RentalObject.vue?vue&type=template&id=6850c070&scoped=true&"
import script from "./RentalObject.vue?vue&type=script&lang=js&"
export * from "./RentalObject.vue?vue&type=script&lang=js&"
import style0 from "./RentalObject.vue?vue&type=style&index=0&id=6850c070&prod&scoped=true&lang=scss&"
import style1 from "./RentalObject.vue?vue&type=style&index=1&id=6850c070&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6850c070",
  null
  
)

export default component.exports